import { Dropdown, getLocale, useTranslator } from "@sia/style-guide";
import { useCallback, useContext, useEffect, useState } from "react";
import { WizarContext, singleSectionInfoActionCreator } from "contexts/WizardContext";
import GlobalContext from "contexts/GlobalContext";
import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { initialWizardFormState } from "contexts/WizardContext";

const SectionInfo = ({ errors, setErrors }) => {
  const translate = useTranslator();
  const { state, dispatch } = useContext(WizarContext);
  const { language } = useContext(GlobalContext);
  let sectionInfo = state.single.sectionInfo;
  let sectionsInfoErrors = errors.single.sectionInfo;
  let changState = useCallback((payload) => dispatch(singleSectionInfoActionCreator(payload)), [dispatch]);
  const professionGroup = "Berufsgruppe Architektur";
  const resetInputFieldError = (property) => {
    if (errors.single.sectionInfo[property]) {
      setErrors((errorsState) => ({
        ...errorsState,
        single: {
          ...errorsState.single,
          sectionInfo: { ...errorsState.single.sectionInfo, [property]: "" },
        },
      }));
    }
  };

  const { user } = useContext(GlobalContext);
  const [sections, setSections] = useState([]);
  const [professionalGroups, setProfessionalGroups] = useState([]);
  const userId = user.siaId;

  const setUserSession = (obj) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = { ...data, single: { ...(data.single || {}), sectionInfo: { ...(data?.single?.sectionInfo || {}), ...obj } } };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const data_sections = await webPlatformAdapter.request("GET", "rpc/get_sia_sections_list", { lang: getLocale(language) });
      let sections = data_sections.map((e) => ({ id: e.id, label: e.name }));
      setSections(sections);
      const data_bgs = await webPlatformAdapter.request("GET", "rpc/get_sia_bgs_list", { lang: getLocale(language) });
      let professionalGroups = data_bgs.map((e) => ({ id: e.id, label: e.name }));
      setProfessionalGroups(professionalGroups);
    }
    if (user) fetchData();
  }, [user, language]);

  useEffect(() => {
    if (userId) {
      pgAdapter.getWizardSession(({ data }) => {
        const defaultSectionInfo = { ...initialWizardFormState.single.sectionInfo };
        const { sectionInfo } = data?.single || {};
        const { section, professionalGroup } = sectionInfo || defaultSectionInfo;
        changState({
          section,
          professionalGroup,
        });
      });
    }
  }, [userId, changState]);
  const selectedSeciton = sections.filter((e) => e.id === sectionInfo?.section?.id)[0];
  const selectedPg = professionalGroups.filter((e) => e.id === sectionInfo?.professionalGroup?.id)[0];
  return (
    <div className="section-info-page">
      <p>{translate("wizard.form.single.sections.info")}</p>
      <Dropdown
        id={"otherAddresses-page-contact"}
        label={translate("wizard.form.single.sections.price.example")}
        items={sections}
        value={selectedSeciton}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("section");
          changState({ section: value });
          setUserSession({ section: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={sectionsInfoErrors.section}
        invalidText={sectionsInfoErrors.section}
      />
      <p>{translate("wizard.form.single.sections.professional-group.info")}</p>
      <Dropdown
        id={"otherAddresses-page-contact-pg"}
        items={professionalGroups}
        value={selectedPg}
        required={true}
        onChange={(event, value) => {
          resetInputFieldError("professionGroup");
          changState({ professionalGroup: value });
          setUserSession({ professionalGroup: value });
        }}
        placeholder={translate("wizard.form.single.placeholder")}
        invalid={sectionsInfoErrors.professionalGroup}
        invalidText={sectionsInfoErrors.professionalGroup}
      />
      <p className="sia-margin-03-top sia-text-03">{professionGroup}</p>
    </div>
  );
};

export default SectionInfo;
